import { createContext, useContext } from "react";

const ImpersonationContext = createContext({
  isImpersonating: false,
  impersonatedVendorId: null,
  impersonatedVendorName: "",
  impersonate: async () => {},
  exitImpersonation: () => {},
});

export const useImpersonation = () => useContext(ImpersonationContext);

export default ImpersonationContext;
